// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"1591":"51ce930283c4921a","5136":"4efe9d5dca467492"}[chunkId] + ".css";
};